import { render, staticRenderFns } from "./ky.vue?vue&type=template&id=4972ceaf&scoped=true&"
import script from "./ky.vue?vue&type=script&lang=js&"
export * from "./ky.vue?vue&type=script&lang=js&"
import style0 from "./ky.vue?vue&type=style&index=0&id=4972ceaf&lang=less&scoped=true&"
import style1 from "./ky.vue?vue&type=style&index=1&id=4972ceaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972ceaf",
  null
  
)

export default component.exports